(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("nl", [], factory);
	else if(typeof exports === 'object')
		exports["nl"] = factory();
	else
		root["$cbSelectPlusI18n"] = root["$cbSelectPlusI18n"] || {}, root["$cbSelectPlusI18n"]["nl"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 